import { Typography } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { ReactNode, memo } from "react";
import { NavLink } from "react-router-dom";

import { useDeviceType } from "@/hooks";
import { StyledListItem } from "@/layout/styles";

function NavItem({
  url,
  icon,
  label,
  trailing,
  end,
  active,
  onClick,
}: {
  url: string;
  icon: ReactNode;
  label: ReactNode;
  trailing?: ReactNode;
  end?: boolean;
  active?: boolean;
  onClick?: () => void;
}) {
  const { isTablet } = useDeviceType();

  const button = (
    <ListItemButton
      onClick={onClick}
      component={NavLink}
      to={url}
      end={end}
      className={active === undefined ? undefined : active ? "active" : ""}
      // On a tablet the menu is a strip of icons, so the name is said here.
      aria-label={isTablet && typeof label === "string" ? label : undefined}
    >
      <ListItemIcon sx={{ ml: isTablet ? 1 : 0 }}>{icon}</ListItemIcon>
      {!isTablet && (
        <>
          <ListItemText primary={label} />

          {trailing && (
            <Typography variant="caption" sx={{ ml: "auto" }}>
              {trailing}
            </Typography>
          )}
        </>
      )}
    </ListItemButton>
  );

  return (
    <StyledListItem disablePadding>
      {/* The strip of icons had no names at all: an icon was the whole of an
          item, and what it was had to be found out by pressing it. */}
      {isTablet ? (
        <Tooltip title={label} placement="right" arrow>
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </StyledListItem>
  );
}

export default memo(NavItem);
